import type { ComponentPublicInstance } from 'vue'

export function handleFrontendError(
  err: unknown,
  instance: ComponentPublicInstance | null,
  info: string
) {
  // Handle frontend error
  console.error(err)

  var error = err as Error

  const componentInfo = {
    name: instance?.$options.name,
    route: instance?.$route?.path,
    props: instance?.$props,
    data: instance?.$data,
    url: window.location.href,
    userAgent: navigator.userAgent,
    timestamp: new Date().toISOString()
  }

  // Send data to Api
  try {
    fetch('/api/EventLog/LogError', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        message: `${error.message} (${info})`,
        exception: error.stack ?? 'No stack trace',
        location:
          componentInfo.name +
          ' - ' +
          componentInfo.route +
          ' - ' +
          componentInfo.props +
          ' - ' +
          componentInfo.data +
          ' - ' +
          componentInfo.url
      })
    })
  } catch (error) {
    console.error('Error while sending error to API')
  }
}

export function reportWarningToBackend(message: string, location: string) {
  // Send data to Api
  try {
    fetch('/api/EventLog/LogWarning', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        message: message,
        exception: 'No Exception',
        location: location
      })
    })
  } catch (error) {
    console.error('Error while sending warning to API')
  }
}
